import {
  IPAddressLabel,
  RFC2544ConfigFieldMapping as ConfigFieldMapping,
  IPAddressValue,
  streamRateConventionValue,
  vlanConfigValue,
  ETHER_TYPE_LABEL,
  DEFAULT_STREAM,
  MAP_STREAM,
  TRANSMIT_INTERFACE_VALUE,
  definedAddressValue
} from '../models/models';
import { TestMode, TestLayerValue, AGENT_MODEL } from '@nrwl/common-lib';
export const RFC2544_AGENT_MODEL_CONFIG = {
  id: 'rfc2544_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'RFC2544',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'rfc2544_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        testMode: {
          enabled: true,
          value: TestMode.LOOPBACK,
          outputField: ConfigFieldMapping.TEST_MODE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        agentTypeSetup: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        layerToTest: {
          enabled: true,
          value: TestLayerValue.L2,
          outputField: ConfigFieldMapping.LAYER_TO_TEST,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          },
          tabId: 'rfc2544_setup'
        },
        streamRateConvention: {
          enabled: true,
          value: streamRateConventionValue.L2,
          outputField: ConfigFieldMapping.STREAM_RATE_CONVENTION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        maxTestDuration: {
          enabled: true,
          value: 7200,
          outputField: ConfigFieldMapping.MAX_TEST_DURATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughput: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.THROUGHPUT,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputDuration: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.THROUGHPUT_DURATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputFrameLossTolerance: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.THROUGHPUT_FRAME_LOSS_TOLERANCE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputStopOverallTestOnFailure: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.THROUGHTPUT_STOP_OVERALL_TEST_ON_FAILURE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputStartingUtilization: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.THROUGHPUT_STARTING_UTILIZATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputMinUtilization: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.THROUGHPUT_MIN_UTILIZATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputMaxUtilization: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.THROUGHPUT_MAX_UTILIZATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        throughputBandwidth: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.THROUGHPUT_BANDWIDTH,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        frameLoss: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.FRAME_LOSS,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        frameLossDuration: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.FRAME_LOSS_DURATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        frameLossMaxLossAllowed: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.FRAME_LOSS_MAX_LOSS_ALLOWED,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        frameLossRunThroughputFails: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.FRAME_LOSS_RUN_THORUGHPUT_FAILS,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        frameLossReduceUtilization: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.FRAME_LOSS_REDUCE_UTILIZATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        latency: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.LATENCY,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        latencyDuration: {
          enabled: true,
          value: 10,
          outputField: ConfigFieldMapping.LATENCY_DURATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        latencyNumOfTrials: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.LATENCY_NUM_OF_TRIALS,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        targetLatency: {
          enabled: true,
          value: 500000,
          outputField: ConfigFieldMapping.TARGET_LATENCY,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        targetFdv: {
          enabled: true,
          value: 200000,
          outputField: ConfigFieldMapping.TARGET_FDV,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        latencyUtilization: {
          enabled: true,
          value: 95,
          outputField: ConfigFieldMapping.LATENCY_UTILIZATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBack: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.BACK_TO_BACK,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackTestType: {
          enabled: true,
          value: 'b2b',
          outputField: ConfigFieldMapping.BACK_TO_BACK_TEST_TYPE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackMaxLineRate: {
          enabled: true,
          value: 10000,
          outputField: ConfigFieldMapping.BACK_TO_BACK_MAX_LINE_RATE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackRepetitions: {
          enabled: true,
          value: 1,
          outputField: ConfigFieldMapping.BACK_TO_BACK_REPETITIONS,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackTargetBurstDuration: {
          enabled: true,
          value: 2,
          outputField: ConfigFieldMapping.BACK_TO_BACK_TARGET_BURST_DURATION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        cbsCommittedBurstSize: {
          enabled: true,
          value: 64,
          outputField: ConfigFieldMapping.CBS_COMMITTED_BURST_SIZE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        cbsKiloByteSize: {
          enabled: true,
          value: 1024,
          outputField: ConfigFieldMapping.CBS_KILO_BYTE_SIZE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackBurstResolution: {
          enabled: true,
          value: 100,
          outputField: ConfigFieldMapping.BACK_TO_BACK_BURST_RESOLUTION,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        backToBackMaxTimeReceiveBurst: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.BACK_TO_BACK_MAX_TIME_RECEIVE_BURST,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: ConfigFieldMapping.SCHEDULER,
          tabId: 'rfc2544_setup',
          restoreOnAgentChange: true
        },
        //endpoints
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'rfc2544_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        networkOverhead: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.NETWORK_OVERHEAD,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        etherType: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.ETHER_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: ETHER_TYPE_LABEL.ETHER_8100, value: ETHER_TYPE_LABEL.ETHER_8100 },
              { name: ETHER_TYPE_LABEL.ETHER_88a8, value: ETHER_TYPE_LABEL.ETHER_88a8 }
            ]
          },
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        deiEnable: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEI_ENABLE,
          tabId: 'rfc2544_endpoints'
        },
        cvlanEthertype: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.CVLAN_ETHER_TYPE,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        vlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SVLAN_ID,
          tabId: 'rfc2544_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        vlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.SVLAN_PRIORITY,
          tabId: 'rfc2544_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.CVLAN_ID,
          tabId: 'rfc2544_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        cvlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.CVLAN_PRIORITY,
          tabId: 'rfc2544_endpoints',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        verifyVlanPriority: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.VERIFY_PRIORITY,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        srcIpV4Address: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_IPV4_ADDRESS,
          tabId: 'rfc2544_endpoints',
          outputOptional: true
        },
        srcIpV6Address: {
          enabled: true,
          value: '2000::280:16ff:fe8a:49f0',
          outputField: ConfigFieldMapping.SRC_IPV6_ADDRESS,
          tabId: 'rfc2544_endpoints',
          outputOptional: true
        },
        srcTestIpAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.SRC_TEST_IP_ADDRESS,
          lookup: ["capabilities.phy['default-test-ip']"],
          tabId: 'rfc2544_endpoints',
          outputOptional: true
        },
        srcSubnet: {
          enabled: true,
          value: '255.255.255.0',
          outputField: ConfigFieldMapping.SRC_SUBNET,
          lookup: ['capabilities.phy.subnet'],
          tabId: 'rfc2544_endpoints',
          outputOptional: true
        },
        srcGateway: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SRC_GATEWAY,
          lookup: ['capabilities.phy.gateway'],
          tabId: 'rfc2544_endpoints',
          outputOptional: true
        },
        destTransmitInterface: {
          enabled: true,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.DEST_TRANSMIT_INTERFACE,
          tabId: 'rfc2544_endpoints'
        },
        destDefinedAddress: {
          enabled: true,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEST_DEFINED_ADDRESS,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        destEditIP: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_IP,
          tabId: 'rfc2544_endpoints'
        },
        destEditMAC: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.DEST_EDIT_MAC,
          tabId: 'rfc2544_endpoints'
        },
        destMacAddress: {
          enabled: true,
          value: '00:AA:BB:CC:DD:EE',
          outputField: ConfigFieldMapping.DESTINATION_MAC,
          lookup: ["capabilities.phy['test-mac-address']"],
          tabId: 'rfc2544_endpoints'
        },
        destIPV4Address: {
          enabled: true,
          value: '192.168.1.2',
          outputField: ConfigFieldMapping.DEST_IPV4_ADDRESS,
          lookup: ["capabilities.phy['default-test-ip']"],
          tabId: 'rfc2544_endpoints'
        },
        destIPV6Address: {
          enabled: true,
          value: 'FE80::1',
          outputField: ConfigFieldMapping.DEST_IPV6_ADDRESS,
          lookup: ["capabilities.loopback['ipv6-address']"],
          tabId: 'rfc2544_endpoints'
        },
        remoteVlanTagCount: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.REMOTE_VLAN_TAG,
          tabId: 'rfc2544_endpoints'
        },
        destShowIpLayer2: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.DEST_SHOW_IP_LAYER2,
          tabId: 'rfc2544_endpoints'
        },
        destShowMacLayer3: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.DEST_SHOW_MAC_LAYER3,
          tabId: 'rfc2544_endpoints'
        },
        suppressLoopCommands: {
          enabled: true,
          value: true,
          outputField: ConfigFieldMapping.SUPPRESS_LOOP_COMMANDS,
          tabId: 'rfc2544_endpoints',
          restoreOnAgentChange: true
        },
        loopbackType: {
          enabled: false,
          value: 'JDSU QT-600 or QT-600-10',
          outputField: ConfigFieldMapping.LOOPBACK_TYPE,
          tabId: 'rfc2544_endpoints'
        },
        // stream
        frameLength: {
          enabled: false,
          value: true,
          outputField: ConfigFieldMapping.FRAME_LENGTH,
          tabId: 'rfc2544_streams'
        },
        stream: {
          enabled: true,
          value: DEFAULT_STREAM,
          outputField: ConfigFieldMapping.STREAM,
          tabId: 'rfc2544_streams'
        },
        maxBandwidth: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.MAX_BANDWIDTH,
          tabId: 'rfc2544_streams',
          outputOptional: true
        },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              frameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              frameList: [
                { label: 78, value: 78, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 78,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'rfc2544_streams'
        },
        validFrameSizesSingle: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_SINGLE,
          tabId: 'rfc2544_streams',
          outputOptional: true
        },
        validFrameSizesDouble: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE_DOUBLE,
          tabId: 'rfc2544_streams',
          outputOptional: true
        },
        framesSizes: {
          enabled: true,
          value: [64, 128, 256, 512, 1024, 1280, 1518],
          outputField: ConfigFieldMapping.FRAME_SIZE,
          tabId: 'rfc2544_streams',
          restoreOnAgentChange: true
        },
        framesSizesSingleVlan: {
          enabled: false,
          value: [],
          outputField: ConfigFieldMapping.FRAME_SIZE_SINGLE,
          tabId: 'rfc2544_streams',
          outputOptional: true
        },
        framesSizesDoubleVlan: {
          enabled: false,
          value: [],
          outputField: ConfigFieldMapping.FRAME_SIZE_DOUBLE,
          tabId: 'rfc2544_streams',
          outputOptional: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    },

    [AGENT_MODEL.QT600]: {
      setup: {
        stream: {
          enabled: true,
          value: DEFAULT_STREAM,
          outputField: ConfigFieldMapping.STREAM,
          tabId: 'rfc2544_streams'
        },
        ipAddressType: {
          enabled: true,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          }
        },
        srcTestIpAddress: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-ip']"]
        },
        srcIpV6Address: { enabled: true },
        validFrameSizes: {
          enabled: true,
          value: {
            multiSelectFrames: false,
            emixFrames: false,
            ipv4: {
              frameList: [
                { label: 64, value: 64, enable: false },
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 64,
              maxValue: 9000,
              selectedVlans: 0
            },
            ipv6: {
              frameList: [
                { label: 128, value: 128, enable: false },
                { label: 256, value: 256, enable: false },
                { label: 512, value: 512, enable: true },
                { label: 1024, value: 1024, enable: false },
                { label: 1280, value: 1280, enable: false },
                { label: 1518, value: 1518, enable: false },
                { label: 9000, value: 9000, enable: false },
                { label: 'custom', value: 300, enable: false }
              ],
              minValue: 128,
              maxValue: 9000,
              selectedVlans: 0
            }
          },
          outputField: ConfigFieldMapping.VALID_FRAME_SIZE,
          tabId: 'rfc2544_streams'
        },
        srcSubnet: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-mask']"]
        },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-gateway']"]
        },
        loopbackType: {
          enabled: true
        },
        trafficClass: { enabled: true },
        hopLimit: { enabled: true }
      }
    },
    [AGENT_MODEL.MAP2100]: {
      setup: {
        stream: {
          enabled: true,
          value: MAP_STREAM,
          outputField: ConfigFieldMapping.STREAM,
          tabId: 'rfc2544_streams'
        },
        srcTestIpAddress: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-ip']"]
        },
        srcSubnet: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-mask']"]
        },
        srcGateway: {
          enabled: true,
          lookup: ["capabilities['phy-list'][{index}]['default-test-gateway']"]
        },
        suppressLoopCommands: {
          value: false
        },
        trafficClass: { enabled: true },
        hopLimit: { enabled: true }
      }
    }
  }
};
